import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { ArtifactAssociationModel } from '../Models/artifact-association-model';
import { CodeLinkageMappingModel } from '../Models/code-linkage-mapping-model';

@Injectable({
  providedIn: 'root'
})
export class CodeLinkageService {

  constructor(private rest:RestService) { }

  public getCodeLinkageFieldsNamesByArtifactId(artifactType:string, artifactId: string): any {
    return this.rest.get("getCodeLinkageFieldsNamesByArtifactId", artifactType, artifactId);
  }

  public getLinkedCodeDataByArtifactId(artifactType: string, artifactId: string): any {
    return this.rest.get("getLinkedCodeData", artifactType, artifactId);
  }

  public isCodeLinkageExistByArtifactId(artifactType: string, artifactId: string): any {
    return this.rest.get("isCodeLinkageExistByArtifactId", artifactType, artifactId);
  }

  public getArtifactAssociationMappings(artifactType:string, artifactId: string): any {
    return this.rest.get("getArtifactAssociationMappings", artifactType, artifactId);
  }

  public deleteArtifactAssociationById(artifactId:string, artifactAssociationId: any): any {
    const id = artifactAssociationId.$oid ? artifactAssociationId.$oid : artifactAssociationId;
    return this.rest.delete("deleteArtifactAssociationById", artifactId, id);
  }

  public deleteCodeLinkageMappingById(codeLinkageMappingId: string): any {
    return this.rest.delete("deleteCodeLinkageMappingById", codeLinkageMappingId);
  } 

  public updateCodeLinkageByUploadedTemplate(artifactId: string, dataRows: string[][]): any {
    let requestData = {
      dataRowsForCL: dataRows
    };
    return this.rest.put('updateCodeLinkageByTemplate', requestData, artifactId);
  }

  public createCodeLinkageByGitCommit(codeLinkageMappingModel: CodeLinkageMappingModel, repoFullName: string, repoBranchName: string, repoCommitId: string, artifactAssociationsList: ArtifactAssociationModel[], dataRows: string[][], artifactId: String): any {
    let requestData = {
      codeLinkageMappingModel: codeLinkageMappingModel,
      repoFullName: repoFullName,
      repoBranchName: repoBranchName,
      repoCommitId: repoCommitId,
      artifactAssociationsForCL: artifactAssociationsList,
      dataRowsForCL: dataRows,
      artifactId: artifactId
    };
    return this.rest.post('createCodeLinkageByGitCommit', requestData);
  }

  public createCodeLinkageByUploadedTemplate(codeLinkageMappingModel: CodeLinkageMappingModel, pmFieldNamesList: string[], tdFieldNamesList: string[], artifactAssociationsList: ArtifactAssociationModel[], dataRows: string[][], artifactId: String): any {
    let requestData = {
      codeLinkageMappingModel: codeLinkageMappingModel,
      dataRowsForCL: dataRows,
      artifactAssociationsForCL: artifactAssociationsList,
      artifactId: artifactId
    };
    return this.rest.post('createCodeLinkageByTemplate', requestData);
  }


  public addArtifactAssociationByArtifactId(artifactId: string, artifactAssociation: ArtifactAssociationModel): any {
    return this.rest.post('addArtifactAssociationByArtifactId', artifactAssociation, artifactId);
  }

  public updateArtifactNameInAssociationsByArtifactId(artifactId: string, artifactType: string, artifactName: string): any {
    let dataModel = {
      _id: artifactId, 
      _type: artifactType,
      name: artifactName
    }
    let requestData = {};
    switch (artifactType) {
      case 'suite':
        requestData = {
            suite: dataModel
        }
        break;
      case 'feature':
        requestData = {
          feature: dataModel
        }
        break;
      case 'scenario':
        requestData = {
          scenario: dataModel
        }
        break;
      case 'step':
        requestData = {
          scenariostep: dataModel
        }
        break;
    }
    return this.rest.put('updateArtifactNameInAssociationsByArtifactId', requestData, artifactType);
  }
}
